// extracted by mini-css-extract-plugin
export var section = "sectionShareButtons-module--section--2d9be";
export var share = "sectionShareButtons-module--share--fbe99";